(function (window) {
  /**
   * Enables pagination events. This can *NOT* be delegated because InfoBoxes
   * need to have enableEventPropagation set to false to be able to select
   * text inside. Since propagation is turned off that means that event
   * delegation will be disabled. So each time an infobox is created we attach
   * new events.
   *
   * @return {undefined}
   */
  window.BatchGeoInfoWindowPageEvents = function () {
    var paginationCluster =
      BatchGeoStore.getState().MapsMarkersManager.paginationCluster;
    var currentPaginationNumber =
      BatchGeoStore.getState().MapsMarkersManager.currentPaginationNumber;

    var paginationCallback = function (currentPaginationNumber) {
      var marker = paginationCluster[currentPaginationNumber].marker;
      BatchGeoStore.dispatch({
        type: "MAPSMARKERS_MANAGER_MARKER_PAGINATE",
        marker: marker,
        currentPaginationNumber: currentPaginationNumber,
      });
    };

    // TODO: Turn these into UI components
    $(".pg .next").on("click", function (e) {
      if (currentPaginationNumber >= paginationCluster.length - 1) return;
      currentPaginationNumber++;
      e.stopPropagation();
      paginationCallback(currentPaginationNumber);
    });
    $(".pg .previous").on("click", function (e) {
      if (currentPaginationNumber <= 0) return;
      currentPaginationNumber--;
      e.stopPropagation();
      paginationCallback(currentPaginationNumber);
    });
  };
})(window);
